import React from 'react';
import { useAuth } from 'oidc-react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AdminGuard from './guards/AdminGuard';
import Debug from './screens/debug/Debug';
import NotFound from './screens/error/NotFound';
import NoAccess from "./screens/no-access/NoAccess";
import Preferences from "./screens/settings/Preferences";
import Transactions from './screens/transactions/Transactions';
import Tronc from './screens/tronc/Tronc';
import Notifications from './screens/settings/Notifications';
import ReportOverview from './screens/dataDownloader/ReportsOverview/ReportOverview';
import GeneratedReports from './screens/dataDownloader/GeneratedReports/GeneratedReports';
import DashboardRootPage from './screens/dashboard/DashboardRootPage';
import DashboardLandingPage from './screens/dashboard/dashboardLandingPage/DashboardLandingPage';

const DEFAULT_PATH = "/home";

const AppRoutes = () => {
    const auth = useAuth();

    return (
        <Routes>
            <Route path="/" element={<Navigate to={DEFAULT_PATH} replace />} />
            <Route path="/debug" element={<Debug />} />
            <Route path="/transactions"
                element={<Transactions />}>
                <Route path=":transactionId" element={null} />
            </Route>
            <Route path="/admin/transactions"
                element={<AdminGuard><Transactions adminView /></AdminGuard>} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/preferences" element={<Preferences />} />
            <Route path="/no-access" element={<NoAccess />} />
            <Route path="*" element={<NotFound />} />
            <Route path="/tronc" element={<Tronc />} />
            <Route path="/dashboards" element={<DashboardRootPage />} />
            <Route path="/home" element={<DashboardLandingPage />} />
            <Route>
                <Route path="/reports-overview" element={<ReportOverview />} />
                <Route path="/reports-hub" element={<GeneratedReports />} />
            </Route>
        </Routes>
    )
};

export default AppRoutes;
